import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		dialog: {
			[theme.breakpoints.down("xs")]: {
				width: "100%",
			},
			width: 600,
		},
		titleDivider: {
			marginLeft: 24,
			marginRight: 24,
		},
		sectionTitle: {
			fontWeight: 700,
			fontSize: 18,
			lineHeight: "24px",
			color: "#5F6368",
		},
		editButton: {
			minWidth: "auto",
			padding: "4px 8px",
			textTransform: "none",
			color: "#36747B",
			fontSize: 16,
			fontWeight: 590,
			lineHeight: "20px",
			borderRadius: 8,
			gap: 4,
		},
		fieldLabel: {
			fontSize: 16,
			fontWeight: 400,
			lineHeight: "24px",
			color: "#5F6368",
		},
		fieldValue: {
			fontSize: 18,
			fontWeight: 400,
			lineHeight: "24px",
			color: "#1C1B1F",
			wordBreak: "break-word" as const,
		},
		agentName: {
			fontSize: 18,
			fontWeight: 700,
			lineHeight: "24px",
			color: "#1C1B1F",
		},
		agentDesignation: {
			fontSize: 18,
			fontWeight: 400,
			lineHeight: "24px",
			color: "#1C1B1F",
		},
		adminText: {
			cursor: "default",
		},
		fieldsContainer: {
			display: "flex",
			flexDirection: "column" as const,
			gap: 24,
			width: "100%",
		},
		fieldRow: {
			display: "flex",
			gap: 24,
			width: "100%",
		},
		fieldCol: {
			flex: "1 0 0",
			display: "flex",
			flexDirection: "column" as const,
			gap: 4,
		},
	} satisfies Record<string, CSSObject>)
}
